const width = 42;


const dashboardSIcon = (props) => {
  return (
    <div style={{ width: width }}>
      <svg
        width="26"
        height="30"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33.3335 13.3333L23.3335 4.56668C22.4168 3.74675 21.23 3.29346 20.0002 3.29346C18.7703 3.29346 17.5835 3.74675 16.6668 4.56668L6.66682 13.3333C6.13744 13.8068 5.71499 14.3876 5.42761 15.0371C5.14023 15.6866 4.99451 16.3898 5.00016 17.1V31.6667C5.00016 32.9928 5.52694 34.2645 6.46462 35.2022C7.40231 36.1399 8.67408 36.6667 10.0002 36.6667H30.0002C31.3262 36.6667 32.598 36.1399 33.5357 35.2022C34.4734 34.2645 35.0002 32.9928 35.0002 31.6667V17.0833C35.0034 16.3759 34.8566 15.6759 34.5693 15.0295C34.282 14.383 33.8608 13.8049 33.3335 13.3333ZM23.3335 33.3333H16.6668V25C16.6668 24.558 16.8424 24.1341 17.155 23.8215C17.4675 23.5089 17.8915 23.3333 18.3335 23.3333H21.6668C22.1089 23.3333 22.5328 23.5089 22.8453 23.8215C23.1579 24.1341 23.3335 24.558 23.3335 25V33.3333ZM31.6668 31.6667C31.6668 32.1087 31.4912 32.5326 31.1787 32.8452C30.8661 33.1577 30.4422 33.3333 30.0002 33.3333H26.6668V25C26.6668 23.6739 26.14 22.4022 25.2024 21.4645C24.2647 20.5268 22.9929 20 21.6668 20H18.3335C17.0074 20 15.7356 20.5268 14.798 21.4645C13.8603 22.4022 13.3335 23.6739 13.3335 25V33.3333H10.0002C9.55813 33.3333 9.13421 33.1577 8.82165 32.8452C8.50909 32.5326 8.33349 32.1087 8.33349 31.6667V17.0833C8.33379 16.8467 8.38448 16.6128 8.48219 16.3973C8.57989 16.1818 8.72238 15.9895 8.90016 15.8333L18.9002 7.08334C19.2043 6.81614 19.5953 6.66879 20.0002 6.66879C20.405 6.66879 20.796 6.81614 21.1002 7.08334L31.1002 15.8333C31.2779 15.9895 31.4204 16.1818 31.5181 16.3973C31.6158 16.6128 31.6665 16.8467 31.6668 17.0833V31.6667Z"
          fill={props.color ?? "#303972"}
        />
      </svg>
    </div>
  );
};


const plusIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.34703 10.6647H0.382324V6.42941H6.34703V0.5H10.5823V6.42941H16.6176V10.6647H10.5823V16.6647H6.34703V10.6647Z"
        fill="#029636"
      />
    </svg>
  );
};

const customerSIcon = (props) => {
  return (
    <div style={{ width: width }}>
      <svg
        width="20"
        height="25"
        viewBox="0 0 26 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7706 0C9.56293 0 6.12731 3.37119 6.12731 7.5C6.12731 11.6288 9.56293 15 13.7706 15C17.9784 15 21.414 11.6288 21.414 7.5C21.414 3.37119 17.9784 0 13.7706 0ZM13.7706 2.25C16.7391 2.25 19.121 4.58718 19.121 7.5C19.121 10.4128 16.7391 12.75 13.7706 12.75C10.8022 12.75 8.42031 10.4128 8.42031 7.5C8.42031 4.58718 10.8022 2.25 13.7706 2.25ZM1.09643 10.4897C0.868296 10.4996 0.648341 10.576 0.464751 10.7092C0.281161 10.8425 0.142301 11.0265 0.0659642 11.2377C-0.0103725 11.4488 -0.020708 11.6776 0.0362816 11.8946C0.0932712 12.1116 0.21499 12.3069 0.385841 12.4556L6.56172 18H4.9808C3.09481 18 1.5413 19.5244 1.5413 21.375V22.2744C1.5413 24.4801 2.96656 26.4585 5.14054 27.8188C7.31451 29.1792 10.289 30 13.7706 30C17.2523 30 20.2268 29.1792 22.4008 27.8188C24.5747 26.4585 26 24.4801 26 22.2744V21.375C26 19.5244 24.4465 18 22.5605 18H9.95943L1.93242 10.7944C1.82088 10.6914 1.68944 10.6114 1.54585 10.5591C1.40227 10.5067 1.24945 10.4832 1.09643 10.4897ZM4.9808 20.25H9.0682L17.0803 27.4424C16.0672 27.6382 14.9592 27.75 13.7706 27.75C10.6607 27.75 8.09317 26.9979 6.37362 25.9219C4.65408 24.8459 3.8343 23.5233 3.8343 22.2744V21.375C3.8343 20.7401 4.3338 20.25 4.9808 20.25ZM12.4644 20.25H22.5605C23.2075 20.25 23.707 20.7401 23.707 21.375V22.2744C23.707 23.5233 22.8872 24.8459 21.1677 25.9219C20.7166 26.2041 20.2043 26.4624 19.642 26.6924L12.4644 20.25Z"
          fill={props.color ?? "#303972"}
        />
      </svg>
    </div>
  );
};

const accountsSIcon = (props) => {
  return (
    <div style={{ width: width }}>
      <svg
        width="26"
        height="30"
        viewBox="0 0 26 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7812 0C10.2253 0 8.9375 1.28313 8.9375 2.83333V4.04762H3.65625C1.65141 4.04762 0 5.69298 0 7.69048V30.3571C0 32.3546 1.65141 34 3.65625 34H22.3438C24.3486 34 26 32.3546 26 30.3571V7.69048C26 5.69298 24.3486 4.04762 22.3438 4.04762H17.0625V2.83333C17.0625 1.28313 15.7747 0 14.2188 0H11.7812ZM11.7812 2.42857H14.2188C14.4585 2.42857 14.625 2.59449 14.625 2.83333V5.06269C14.6035 5.19304 14.6035 5.32602 14.625 5.45638V6.88095C14.625 7.1198 14.4585 7.28571 14.2188 7.28571H11.7812C11.5415 7.28571 11.375 7.1198 11.375 6.88095V5.46112C11.3965 5.33077 11.3965 5.19779 11.375 5.06743V2.83333C11.375 2.59449 11.5415 2.42857 11.7812 2.42857ZM3.65625 6.47619H8.9375V6.88095C8.9375 8.43115 10.2253 9.71429 11.7812 9.71429H14.2188C15.7747 9.71429 17.0625 8.43115 17.0625 6.88095V6.47619H22.3438C23.0315 6.47619 23.5625 7.00522 23.5625 7.69048V30.3571C23.5625 31.0424 23.0315 31.5714 22.3438 31.5714H3.65625C2.96847 31.5714 2.4375 31.0424 2.4375 30.3571V7.69048C2.4375 7.00522 2.96847 6.47619 3.65625 6.47619ZM10.8719 11.3349C9.17978 11.3349 7.69564 12.5072 7.31091 14.1493L6.65393 16.951C6.63854 17.0186 6.62898 17.0873 6.62537 17.1565C6.04657 17.7412 5.6875 18.5425 5.6875 19.4286V23.4762C5.6875 23.923 6.0515 24.2857 6.5 24.2857H8.125C8.5735 24.2857 8.9375 23.923 8.9375 23.4762V22.6667H17.0625V23.4762C17.0625 23.923 17.4265 24.2857 17.875 24.2857H19.5C19.9485 24.2857 20.3125 23.923 20.3125 23.4762V19.4286C20.3125 18.5535 19.9599 17.763 19.3937 17.1802C19.3895 17.15 19.3842 17.12 19.3778 17.0901L18.6875 14.1493C18.3037 12.506 16.8202 11.3349 15.1281 11.3349H10.8719ZM10.8719 13.7635H15.1281C15.7011 13.7635 16.1838 14.1441 16.3135 14.6995L16.3151 14.7011L16.6642 16.1905H9.33582L9.68494 14.7011C9.81534 14.1445 10.2989 13.7635 10.8719 13.7635ZM9.34375 18.619C10.0165 18.619 10.5625 19.163 10.5625 19.8333C10.5625 20.5036 10.0165 21.0476 9.34375 21.0476C8.671 21.0476 8.125 20.5036 8.125 19.8333C8.125 19.163 8.671 18.619 9.34375 18.619ZM16.6562 18.619C17.329 18.619 17.875 19.163 17.875 19.8333C17.875 20.5036 17.329 21.0476 16.6562 21.0476C15.9835 21.0476 15.4375 20.5036 15.4375 19.8333C15.4375 19.163 15.9835 18.619 16.6562 18.619ZM6.90625 26.7143C6.74475 26.712 6.58441 26.7417 6.43454 26.8017C6.28467 26.8617 6.14827 26.9508 6.03326 27.0638C5.91824 27.1768 5.82692 27.3114 5.76458 27.4599C5.70224 27.6083 5.67014 27.7676 5.67014 27.9286C5.67014 28.0895 5.70224 28.2488 5.76458 28.3973C5.82692 28.5457 5.91824 28.6804 6.03326 28.7933C6.14827 28.9063 6.28467 28.9954 6.43454 29.0554C6.58441 29.1154 6.74475 29.1451 6.90625 29.1429H19.0938C19.2552 29.1451 19.4156 29.1154 19.5655 29.0554C19.7153 28.9954 19.8517 28.9063 19.9667 28.7933C20.0818 28.6804 20.1731 28.5457 20.2354 28.3973C20.2978 28.2488 20.3299 28.0895 20.3299 27.9286C20.3299 27.7676 20.2978 27.6083 20.2354 27.4599C20.1731 27.3114 20.0818 27.1768 19.9667 27.0638C19.8517 26.9508 19.7153 26.8617 19.5655 26.8017C19.4156 26.7417 19.2552 26.712 19.0938 26.7143H6.90625Z"
          fill={props.color ?? "#303972"}
        />
      </svg>
    </div>
  );
};


const categoriesSIcon = (props) => {

  return (
    <div style={{ width: width }}>
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5 10h2c2 0 3-1 3-3V5c0-2-1-3-3-3H5C3 2 2 3 2 5v2c0 2 1 3 3 3zM17 10h2c2 0 3-1 3-3V5c0-2-1-3-3-3h-2c-2 0-3 1-3 3v2c0 2 1 3 3 3zM17 22h2c2 0 3-1 3-3v-2c0-2-1-3-3-3h-2c-2 0-3 1-3 3v2c0 2 1 3 3 3zM5 22h2c2 0 3-1 3-3v-2c0-2-1-3-3-3H5c-2 0-3 1-3 3v2c0 2 1 3 3 3z"
          stroke="#292D32"
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}


const settingsSIcon = (props) => {
  return (
    <div style={{ width: width }}>
      <svg
        width="26"
        height="30"
        viewBox="0 0 30 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.19351 15.8037C9.19351 12.5947 11.7471 9.99121 15.0304 9.99121C18.2528 9.99121 20.8673 12.5947 20.8673 15.8037C20.8673 19.0127 18.2528 21.6162 15.0304 21.6162C11.7471 21.6162 9.19351 19.0127 9.19351 15.8037ZM15.0304 12.8975C13.3888 12.8975 12.112 14.2295 12.112 15.8037C12.112 17.4385 13.3888 18.71 15.0304 18.71C16.6112 18.71 17.9488 17.4385 17.9488 15.8037C17.9488 14.2295 16.6112 12.8975 15.0304 12.8975ZM17.28 0.303711C18.6177 0.303711 19.7729 1.27246 20.0769 2.54395L20.5633 4.54199C21.1105 4.78418 21.5969 5.08691 22.0225 5.38965L24.0289 4.78418C25.3058 4.4209 26.7042 4.96582 27.373 6.11621L29.6226 10.0518C30.2914 11.2021 30.0482 12.6553 29.0754 13.5635L27.6162 14.9561C27.6162 15.2588 27.677 15.5615 27.677 15.8037C27.677 16.1064 27.6162 16.4092 27.6162 16.6514L29.0754 18.1045C30.0482 19.0127 30.2914 20.4658 29.6226 21.6162L27.373 25.5518C26.7042 26.7021 25.3058 27.2471 24.0289 26.8838L22.0225 26.2783C21.5969 26.5811 21.1105 26.8838 20.5633 27.126L20.0769 29.124C19.7729 30.3955 18.6177 31.3037 17.28 31.3037H12.72C11.3823 31.3037 10.2271 30.3955 9.92312 29.124L9.43671 27.126C8.8895 26.8838 8.4031 26.5811 7.97749 26.2783L5.97106 26.8838C4.69424 27.2471 3.29582 26.7021 2.62701 25.5518L0.377372 21.6162C-0.291439 20.4658 -0.0482349 19.0127 0.92458 18.1045L2.3838 16.6514C2.3838 16.4092 2.3838 16.1064 2.3838 15.8037C2.3838 15.5615 2.3838 15.2588 2.3838 14.9561L0.92458 13.5635C-0.0482349 12.6553 -0.291439 11.2021 0.377372 10.0518L2.62701 6.11621C3.29582 4.96582 4.69424 4.4209 5.97106 4.78418L7.97749 5.38965C8.4031 5.08691 8.8895 4.78418 9.43671 4.54199L9.92312 2.54395C10.2271 1.27246 11.3823 0.303711 12.72 0.303711H17.28ZM11.9296 6.60059L11.2607 6.90332C10.4703 7.20605 9.74072 7.62988 9.13271 8.11426L8.5247 8.59863L5.18065 7.56934L2.93101 11.5049L5.42385 13.8662L5.36305 14.5928C5.30225 15.0166 5.30225 15.4404 5.30225 15.8037C5.30225 16.2275 5.30225 16.6514 5.36305 17.0752L5.42385 17.8018L2.93101 20.1631L5.18065 24.0986L8.5247 23.0693L9.13271 23.5537C9.74072 24.0381 10.4703 24.4619 11.2607 24.7646L11.9296 25.0674L12.72 28.3975H17.28L18.0704 25.0674L18.7393 24.7646C19.5297 24.4619 20.2593 24.0381 20.8673 23.5537L21.4753 23.0693L24.8194 24.0986L27.069 20.1631L24.5761 17.8018L24.6369 17.0752C24.6978 16.6514 24.7586 16.2275 24.7586 15.8037C24.7586 15.4404 24.6978 15.0166 24.6369 14.5928L24.5761 13.8662L27.069 11.5049L24.8194 7.56934L21.4753 8.59863L20.8673 8.11426C20.2593 7.62988 19.5297 7.20605 18.7393 6.90332L18.0704 6.60059L17.28 3.20996H12.72L11.9296 6.60059Z"
          fill={props.color ?? "#303972"}
        />
      </svg>
    </div>
  );
};

function notficationsSIcon(props) {

  return (
    <div style={{ width: width }}>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="30"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fill={props.color ?? "#303972"}
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M11.554 2.797a5.772 5.772 0 00-5.768 5.767v2.778c0 .586-.25 1.48-.547 1.98l-1.106 1.836c-.682 1.134-.211 2.394 1.038 2.816a20.11 20.11 0 0012.755 0 1.925 1.925 0 001.038-2.816l-1.105-1.836c-.288-.5-.538-1.393-.538-1.98V8.564c0-3.172-2.595-5.767-5.767-5.767z"
        ></path>
        <path
          fill={props.color ?? "#303972"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M13.332 3.076a6.492 6.492 0 00-3.556 0 1.908 1.908 0 011.778-1.211c.807 0 1.5.5 1.778 1.21z"
        ></path>
        <path
          fill={props.color ?? "#303972"}
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M14.437 18.32a2.892 2.892 0 01-2.883 2.884 2.894 2.894 0 01-2.038-.846 2.894 2.894 0 01-.846-2.037"
        ></path>
      </svg>
    </div>
  );
}



const logoutIcon = (props) => {
  return (
    <div style={{ width: width }}>
      <svg
        width="27"
        height="25"
        viewBox="0 0 27 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1345 23.3007C10.1345 24.0507 9.5539 24.5864 8.86771 24.5864H5.06726C2.21693 24.5864 0 22.3364 0 19.4436V5.72928C0 2.89 2.21693 0.586426 5.06726 0.586426H8.86771C9.5539 0.586426 10.1345 1.17571 10.1345 1.87214C10.1345 2.62214 9.5539 3.15785 8.86771 3.15785H5.06726C3.6421 3.15785 2.53363 4.33643 2.53363 5.72928V19.4436C2.53363 20.89 3.6421 22.015 5.06726 22.015H8.86771C9.5539 22.015 10.1345 22.6043 10.1345 23.3007ZM26.6559 11.7293L19.9523 4.44357C19.4773 3.90785 18.6855 3.90785 18.1577 4.39C17.6299 4.87214 17.6299 5.67571 18.1049 6.21143L22.8027 11.3007H9.65947C8.97328 11.3007 8.44544 11.89 8.44544 12.5864C8.44544 13.3364 8.97328 13.8721 9.65947 13.8721H22.7499L17.9993 19.015C17.5243 19.5507 17.5243 20.3543 18.0521 20.8364C18.3688 21.0507 18.6855 21.1579 18.9495 21.1579C19.2662 21.1579 19.5829 21.0507 19.8468 20.7829L26.5503 13.4971C27.131 13.015 27.131 12.2114 26.6559 11.7293Z"
          fill={props.color ?? "#303972"}
        />
      </svg>
    </div>
  );
};

const logoIcon = (props) => {
  return (
    <svg
      width={219}
      height={182}
      viewBox="0 0 219 182"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.305 163.345l-6.93-12.24h-2.97v12.24h-6.3v-31.41h11.79c2.43 0 4.5.435 6.21 1.305 1.71.84 2.985 1.995 3.825 3.465.87 1.44 1.305 3.06 1.305 4.86 0 2.07-.6 3.945-1.8 5.625-1.2 1.65-2.985 2.79-5.355 3.42l7.515 12.735h-7.29zm-9.9-16.965h5.265c1.71 0 2.985-.405 3.825-1.215.84-.84 1.26-1.995 1.26-3.465 0-1.44-.42-2.55-1.26-3.33-.84-.81-2.115-1.215-3.825-1.215H9.405v9.225zm45.703 3.96c0 .9-.06 1.71-.18 2.43H36.703c.15 1.8.78 3.21 1.89 4.23 1.11 1.02 2.475 1.53 4.095 1.53 2.34 0 4.005-1.005 4.995-3.015h6.795c-.72 2.4-2.1 4.38-4.14 5.94-2.04 1.53-4.545 2.295-7.515 2.295-2.4 0-4.56-.525-6.48-1.575-1.89-1.08-3.375-2.595-4.455-4.545-1.05-1.95-1.575-4.2-1.575-6.75 0-2.58.525-4.845 1.575-6.795 1.05-1.95 2.52-3.45 4.41-4.5 1.89-1.05 4.065-1.575 6.525-1.575 2.37 0 4.485.51 6.345 1.53a10.555 10.555 0 014.365 4.365c1.05 1.86 1.575 4.005 1.575 6.435zm-6.525-1.8c-.03-1.62-.615-2.91-1.755-3.87-1.14-.99-2.535-1.485-4.185-1.485-1.56 0-2.88.48-3.96 1.44-1.05.93-1.695 2.235-1.935 3.915h11.835zm24.939-10.485c2.97 0 5.37.945 7.2 2.835 1.83 1.86 2.745 4.47 2.745 7.83v14.625h-6.3v-13.77c0-1.98-.495-3.495-1.485-4.545-.99-1.08-2.34-1.62-4.05-1.62-1.74 0-3.12.54-4.14 1.62-.99 1.05-1.485 2.565-1.485 4.545v13.77h-6.3v-24.93h6.3v3.105c.84-1.08 1.905-1.92 3.195-2.52 1.32-.63 2.76-.945 4.32-.945zm23.27 5.535v12.06c0 .84.195 1.455.585 1.845.42.36 1.11.54 2.07.54h2.926v5.31h-3.96c-5.31 0-7.965-2.58-7.965-7.74V143.59h-2.97v-5.175h2.97v-6.165h6.345v6.165h5.58v5.175h-5.58zm62.819-11.655l-8.775 31.41h-7.425l-5.895-22.365-6.165 22.365-7.38.045-8.46-31.455h6.75l5.535 24.39 6.39-24.39h7.02l6.03 24.255 5.58-24.255h6.795zm2.494 18.855c0-2.52.495-4.755 1.485-6.705 1.02-1.95 2.385-3.45 4.095-4.5 1.74-1.05 3.675-1.575 5.805-1.575 1.86 0 3.48.375 4.86 1.125 1.41.75 2.535 1.695 3.375 2.835v-3.555h6.345v24.93h-6.345V159.7c-.81 1.17-1.935 2.145-3.375 2.925-1.41.75-3.045 1.125-4.905 1.125-2.1 0-4.02-.54-5.76-1.62-1.71-1.08-3.075-2.595-4.095-4.545-.99-1.98-1.485-4.245-1.485-6.795zm19.62.09c0-1.53-.3-2.835-.9-3.915-.6-1.11-1.41-1.95-2.43-2.52a6.37 6.37 0 00-3.285-.9 6.38 6.38 0 00-3.24.855c-.99.57-1.8 1.41-2.43 2.52-.6 1.08-.9 2.37-.9 3.87s.3 2.82.9 3.96c.63 1.11 1.44 1.965 2.43 2.565 1.02.6 2.1.9 3.24.9 1.17 0 2.265-.285 3.285-.855 1.02-.6 1.83-1.44 2.43-2.52.6-1.11.9-2.43.9-3.96zm36.348-12.465l-15.435 36.72h-6.705l5.4-12.42-9.99-24.3h7.065l6.435 17.415 6.525-17.415h6.705z"
        fill="#F7B500"
      />
      <g clipPath="url(#clip0_210_2466)">
        <path
          d="M104.43 50.53c-.38 1.13-1.01 1.53-1.51 2.03-6.32 6.34-12.68 12.65-18.97 19.03-1.16 1.17-2.34 1.67-3.99 1.66-17.75-.05-35.5-.03-53.25-.03-.48 0-.96-.03-1.44-.01-.92.03-1.31-.41-1.26-1.31.02-.48 0-.96 0-1.44V2.8c0-.4.02-.8 0-1.2-.09-1.1.32-1.68 1.5-1.57.56.05 1.12 0 1.68 0 30.62 0 61.24.01 91.86-.03 1.72 0 2.98.42 4.21 1.69 4.5 4.65 9.13 9.19 13.7 13.78 1.51 1.51 1.51 1.54.1 2.95-4.46 4.47-8.92 8.94-13.4 13.4-1.27 1.27-1.3 1.26-2.59-.02-1.93-1.91-3.89-3.8-5.75-5.78-.96-1.02-2-1.37-3.38-1.36-11.59.04-23.19.02-34.78.02H50.3c-.75.01-1.21.33-1.2 1.14 0 .4-.01.8-.01 1.2v21.11c0 2.35.02 2.38 2.36 2.38H104.43v.02zM163.23 73.33c-1.39.37-2.4-.14-3.39-1.15-5.22-5.3-10.5-10.53-15.75-15.8-1.67-1.67-1.52-1.66-3.13-.05-5.14 5.15-10.31 10.27-15.4 15.46-1.2 1.23-2.4 1.81-4.17 1.78-9.59-.12-19.18-.1-28.78-.14-.69 0-1.41.18-2.08-.22-.04-.7.53-.97.89-1.33 16.33-16.35 32.66-32.69 49-49.03.33-.33.73-.61 1.09-.91.76-.19.8.38.76.82-.11 1.25.6 1.72 1.67 1.89.32.05.75.04.9.27 1.32 2.16 3.65 3.36 5.1 5.34.62.85.98 1.79 2.12 2.05.15.03.36.1.41.22 1.19 2.56 4.22 3.44 5.42 5.97.29.62.64 1.09 1.31 1.28.31.09.72.16.86.4 1.37 2.41 4.12 3.54 5.49 5.93.33.58.6 1.12 1.27 1.32 1.32.41 2.2 1.27 2.62 2.59.21.67.65 1.08 1.3 1.29.31.1.73.17.85.4 1.34 2.44 4.15 3.51 5.47 5.94.32.59.61 1.11 1.28 1.31 1.32.4 2.21 1.26 2.6 2.59.23.78.83 1.11 1.54 1.36.69.24 1.42.59 1.68 1.27.58 1.51 2.13 2.11 2.93 3.18 1.65 2.2 3.88 3.57 6.16 5.18-1.01.84-1.92.55-2.74.55-8.32.03-16.63 0-24.95.03-.78 0-1.6-.21-2.35.2l.02.01zM116.47 97.08c-.82-3.55-3.04-5.91-6.52-7.05-1.99-.66-4.04-.87-6.14-.86-11.03.01-22.07.01-33.1.01v-.03H37.37c-.88 0-1.76.01-2.64.11-4.88.53-8.5 3.41-9.47 7.87-1.14 5.23 0 10.51 4.09 13.43 1.12.8 2.37 1.32 3.69 1.69 1.56.44 3.15.5 4.75.5h65.73c.88 0 1.76.01 2.63-.06 5.39-.45 9.08-3.37 10.28-8.24.6-2.43.6-4.94.04-7.37zm-78.73 8.48c-2.51-.07-4.55-2.16-4.53-4.66.02-2.58 2.21-4.65 4.85-4.58 2.51.07 4.58 2.19 4.54 4.66-.05 2.6-2.23 4.66-4.86 4.58zM194.05 81.17c-.12.69-.71 1.03-1.15 1.47-9.6 9.62-19.21 19.22-28.79 28.86-.96.97-1.94 1.45-3.35 1.44-10.55-.05-21.1-.03-31.65-.03-.47 0-.94-.05-1.37-.07-.36-.71.22-.92.52-1.21 5.72-5.62 8.73-12.5 9.48-20.43.18-1.91.17-1.94 2.1-1.95 3.68-.02 7.36-.15 11.03.05 2.1.11 3.44-.61 4.63-2.22 1.33-1.8 2.88-3.42 4.28-5.17.61-.76 1.3-1.08 2.25-1.08 10.31.01 20.62 0 30.93 0 .39 0 .8-.04 1.1.34h-.01z"
          fill="#F7B500"
        />
        <path
          d="M160.94 71.72c.83-.7 1.84-.44 2.77-.44 8-.02 16-.01 23.99-.01h2.32c-.86-.71-1.68-1.29-2.71-1.45-1.07-.17-1.72-.81-1.89-1.88-.19-1.29-.81-2.02-2.22-1.98-1.07.03-1.64-.61-1.61-1.66.03-1.51-.63-2.21-2.15-2.17-1.2.03-1.73-.69-1.7-1.83.03-1.43-.68-2.03-2.06-2-1.18.02-1.79-.59-1.77-1.77.03-1.38-.57-2.1-2-2.07-1.14.03-1.86-.49-1.83-1.7.04-1.53-.66-2.19-2.17-2.16-1.05.02-1.68-.54-1.66-1.61.02-1.46-.54-2.27-2.11-2.22-1.18.04-1.78-.62-1.75-1.78.03-1.39-.6-2.08-2.01-2.05-1.33.03-1.86-.71-1.84-1.96.02-1.31-.65-1.9-1.93-1.87-1.29.02-1.94-.6-1.91-1.89.04-1.45-.75-1.98-2.1-1.96-1.19.02-1.76-.65-1.73-1.81.03-1.41-.63-2.06-2.03-2.03-1.16.03-1.82-.55-1.8-1.74.02-1.36-.51-2.14-1.97-2.1-1.3.03-1.91-.63-1.89-1.91.02-1.28-.57-1.94-1.88-1.93-.56 0-1.14-.02-1.57-.46-.69-.69-1.46-1.37-.34-2.35.2-.17.03-.44-.17-.61.29-.53.61-1.01 1.27-.44.36.31.69.66 1.03 1 16.27 16.28 32.54 32.56 48.81 48.85.54.54 1.03 1.13 1.52 1.67-.4.53-.82.42-1.19.42h-28.77c-.32 0-.63-.07-.95-.1z"
          fill="#F5B405"
        />
        <path
          d="M123.18 81.2c.07 2.04-1.61 3.87-3.68 3.99-2.13.13-4.06-1.64-4.13-3.79-.06-2.05 1.59-3.86 3.67-4 2.11-.14 4.05 1.65 4.13 3.79l.01.01z"
          fill="#F5B402"
        />
        <path
          d="M96.16 81.68c-.17 2.09-2.01 3.69-4.07 3.55-2.12-.14-3.87-2.17-3.66-4.25.21-2.06 2.07-3.67 4.11-3.54 2.2.14 3.8 2.01 3.62 4.23v.01z"
          fill="#F4B302"
        />
        <path
          d="M27.77 85.23c-2.05-.07-3.76-1.86-3.74-3.92.02-2.19 1.86-3.98 4-3.89 2.17.09 3.85 1.96 3.73 4.16-.12 2.07-1.92 3.72-3.99 3.65zM46.49 81.27c.05 2.02-1.67 3.85-3.73 3.96-2.14.12-4.03-1.66-4.06-3.83a3.866 3.866 0 013.69-3.94c2.16-.1 4.05 1.65 4.1 3.81z"
          fill="#F5B402"
        />
        <path
          d="M109.6 81.29c.02 2.19-1.78 3.99-3.95 3.94-2.05-.05-3.8-1.82-3.82-3.86-.02-2.14 1.84-3.99 3.98-3.94 2.08.05 3.76 1.76 3.78 3.86h.01z"
          fill="#F4B302"
        />
        <path
          d="M60.49 81.24c.05 2.11-1.82 4.03-3.92 4-2.08-.02-3.77-1.72-3.82-3.82-.04-2.13 1.54-3.86 3.63-3.98 2.13-.12 4.05 1.65 4.1 3.8h.01z"
          fill="#F4B403"
        />
        <path
          d="M70.4 85.21c-2.07-.06-3.73-1.8-3.72-3.92 0-2.19 1.83-3.97 3.99-3.89 2.06.08 3.75 1.85 3.75 3.91 0 2.14-1.88 3.96-4.02 3.89v.01z"
          fill="#F5B402"
        />
      </g>
      <defs>
        <clipPath id="clip0_210_2466">
          <path
            fill="#fff"
            transform="translate(24)"
            d="M0 0H170.05V112.94H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
};


const totalSalesIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.2362 21.8435C33.9952 21.0315 31.5093 21.212 29.4073 22.3374L25.9808 23.8788C25.704 22.3007 24.4919 21.1148 22.9959 21.0692C22.9871 21.069 17.8583 21.0111 17.8583 21.0111C13.7532 19.885 11.0858 21.332 9.56421 22.7579C9.25301 23.0496 8.97934 23.3498 8.73848 23.646C8.32788 23.2038 7.6031 23.0856 7.07455 23.3762L2.41891 25.9354C1.81506 26.2674 1.55233 26.9956 1.80558 27.6358L6.35549 39.1377C6.65447 39.8934 7.57327 40.2274 8.29019 39.8333L12.9458 37.2742C13.3822 37.0343 13.6392 36.5873 13.6533 36.1162H20.6018C21.7352 36.1162 22.8542 35.8185 23.8378 35.2553C23.8378 35.2553 36.9062 27.7589 36.9799 27.6919C38.81 26.027 38.8664 22.7966 36.2362 21.8435C37.2854 22.2237 33.9952 21.0315 36.2362 21.8435ZM8.33182 36.688L4.79643 27.7508L7.03267 26.5216L10.5681 35.4588L8.33182 36.688ZM35.2312 25.5773L22.4744 32.8826C21.9051 33.2087 21.2575 33.381 20.6016 33.381H12.6916L10.0357 26.667C10.2632 26.2034 10.7113 25.4342 11.4391 24.7522C12.9296 23.3555 14.8942 22.998 17.2787 23.6898C17.398 23.7244 17.5214 23.7427 17.6455 23.7441L22.9176 23.8034C23.0522 23.815 23.3007 24.1143 23.3007 24.5679C23.3007 25.035 23.0441 25.3327 22.9099 25.3327H17.7299V28.0679H22.9099C23.5516 28.0679 24.1488 27.8509 24.6459 27.4791L30.5775 24.8109C30.609 24.7968 30.6398 24.7815 30.67 24.765C32.0929 23.9914 33.7811 23.8636 35.3015 24.4145C35.9031 24.6327 35.4685 25.3364 35.2312 25.5773ZM26.9996 19.7079C21.5665 19.7079 17.1463 15.2874 17.1463 9.85393C17.1463 4.42051 21.5664 0 26.9996 0C32.4328 0 36.8528 4.42051 36.8528 9.85393C36.8528 15.2874 32.4327 19.7079 26.9996 19.7079ZM26.9996 2.73521C23.0771 2.73521 19.886 5.92863 19.886 9.85393C19.886 13.7792 23.0772 16.9727 26.9996 16.9727C30.9222 16.9727 34.1133 13.7791 34.1133 9.85393C34.1133 5.92872 30.9221 2.73521 26.9996 2.73521Z"
        fill="white"
      />
      <path
        d="M27.6358 8.73914C26.5464 8.29179 26.4622 8.09957 26.4622 7.87675C26.4622 7.73444 26.5328 7.40359 27.1871 7.40359C27.7857 7.40359 28.5315 7.73957 29.0575 8.08581L29.7892 6.16786C29.2668 5.8353 28.6319 5.54957 28.0383 5.4582V4.21094H26.0874V5.57957C24.9284 5.94487 24.2142 6.87136 24.2142 8.0247C24.2142 9.55222 25.4363 10.2342 26.6299 10.6991C27.5836 11.0827 27.6635 11.3764 27.6635 11.6216C27.6635 11.9988 27.3159 12.2425 26.778 12.2425C26.0765 12.2425 25.2609 11.8379 24.6899 11.3951L23.9858 13.3438C24.5681 13.7953 25.2421 14.0932 26.0005 14.2044V15.4968H27.9635V14.09C29.1587 13.7094 29.9237 12.7192 29.9237 11.5353C29.9237 9.87803 28.7011 9.17051 27.6358 8.73914Z"
        fill="white"
      />
    </svg>
  );
};

const totalProfitsIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_188_809)">
        <path
          d="M11.4668 30.2498V26.7998"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M20 30.2501V23.3501"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M28.5332 30.25V19.8833"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M28.5335 9.75L27.7668 10.65C23.5168 15.6167 17.8168 19.1333 11.4668 20.7167"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M23.6504 9.75H28.5337V14.6167"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.0007 36.6668H25.0007C33.334 36.6668 36.6673 33.3335 36.6673 25.0002V15.0002C36.6673 6.66683 33.334 3.3335 25.0007 3.3335H15.0007C6.66732 3.3335 3.33398 6.66683 3.33398 15.0002V25.0002C3.33398 33.3335 6.66732 36.6668 15.0007 36.6668Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_188_809">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const searchIcon = (props) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1855 19.9348L16.1496 14.8989C17.5004 13.3458 18.3183 11.3195 18.3183 9.10473C18.3183 4.22958 14.353 0.26881 9.48241 0.26881C4.60726 0.26881 0.646484 4.23418 0.646484 9.10473C0.646484 13.9753 4.61185 17.9407 9.48241 17.9407C11.6971 17.9407 13.7235 17.1228 15.2765 15.7719L20.3125 20.8078C20.432 20.9273 20.5928 20.9916 20.749 20.9916C20.9052 20.9916 21.0661 20.9319 21.1855 20.8078C21.4245 20.5689 21.4245 20.1738 21.1855 19.9348ZM1.8825 9.10473C1.8825 4.91422 5.29189 1.50942 9.47781 1.50942C13.6683 1.50942 17.0731 4.91881 17.0731 9.10473C17.0731 13.2907 13.6683 16.7046 9.47781 16.7046C5.29189 16.7046 1.8825 13.2952 1.8825 9.10473Z"
        fill={props.color ?? "#03C068"}
      />
    </svg>
  );
};



const imageUplaodIcon = (props) => {
  return <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M34.4502 9.85458C33.8158 9.72808 33.2963 9.33133 33.028 8.76399C30.0572 2.49458 23.1706 -1.01101 16.2878 0.257828C10.0165 1.40783 5.10025 6.41416 4.05183 12.7181C3.74133 14.5792 3.76433 16.4422 4.11508 18.2572C4.23008 18.8495 3.97517 19.5088 3.45192 19.9842C1.25733 21.9794 0 24.8218 0 27.785C0 33.5963 4.72842 38.3267 10.5417 38.3267H31.625C39.5523 38.3267 46 31.879 46 23.9517C46 17.1187 41.1432 11.1886 34.4502 9.85458ZM31.625 34.4914H10.5417C6.8425 34.4914 3.83333 31.4822 3.83333 27.7831C3.83333 25.899 4.6345 24.0877 6.02983 22.8189C7.53633 21.4485 8.24358 19.4207 7.87558 17.5232C7.61108 16.1585 7.59575 14.7536 7.82958 13.3429C8.602 8.70074 12.3625 4.86933 16.974 4.02408C17.7119 3.88991 18.446 3.82474 19.1705 3.82474C23.6018 3.82474 27.6134 6.29533 29.5627 10.4066C30.3542 12.0779 31.8627 13.2471 33.6988 13.6132C38.6055 14.5926 42.1647 18.9396 42.1647 23.9517C42.1647 29.763 37.4344 34.4933 31.6231 34.4933L31.625 34.4914ZM28.9819 19.7197C29.7313 20.4691 29.7313 21.6804 28.9819 22.4298C28.6082 22.8036 28.1175 22.9914 27.6268 22.9914C27.1362 22.9914 26.6455 22.8036 26.2717 22.4298L23 19.1581V28.7414C23 29.8013 22.1413 30.6581 21.0833 30.6581C20.0253 30.6581 19.1667 29.8013 19.1667 28.7414V19.1581L15.8949 22.4298C15.1455 23.1792 13.9342 23.1792 13.1848 22.4298C12.4353 21.6804 12.4353 20.4691 13.1848 19.7197L18.3732 14.5312C19.113 13.7914 20.0847 13.4196 21.0565 13.4138L21.0833 13.4081L21.1102 13.4138C22.0838 13.4196 23.0537 13.7914 23.7935 14.5312L28.9819 19.7197Z"
      fill="#C5C5C5"
    />
  </svg>
}

function eyeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="16"
      fill="none"
      viewBox="0 0 28 16"
    >
      <path
        fill="rgba(247, 181, 0)"
        d="M14.001 16C7.28 16.01.668 12.42.668 8c0-4.419 6.645-8.023 13.333-8 6.688.023 13.334 3.581 13.334 8 0 4.419-6.611 7.99-13.334 8zm0-2.667a5.333 5.333 0 100-10.666 5.333 5.333 0 000 10.666zm0-2.666a2.667 2.667 0 110-5.334 2.667 2.667 0 010 5.334z"
      ></path>
    </svg>
  );
}


const clientsDIcon = () => {
  return (
    <svg
      width="22"
      height="30"
      viewBox="0 0 30 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9288 37.75H3.75C1.67875 37.75 0 36.0713 0 34V23.5863C0 21.7738 1.29625 20.2213 3.07875 19.8975C5.72125 19.4163 10.2775 18.5875 12.855 18.12C14.2737 17.8612 15.7263 17.8612 17.145 18.12C19.7225 18.5875 24.2788 19.4163 26.9213 19.8975C28.7038 20.2213 30 21.7738 30 23.5863C30 26.3125 30 31.0825 30 34C30 36.0713 28.3212 37.75 26.25 37.75H12.9288ZM24.785 22.05L24.79 22.0563C25.0088 22.3838 25.06 22.795 24.9287 23.1662L24.0462 25.6662C23.9312 25.9925 23.685 26.2575 23.3675 26.3963L21.7075 27.12L22.3675 28.4412C22.5525 28.81 22.5425 29.2462 22.3425 29.6075L19.2075 35.25H26.25C26.94 35.25 27.5 34.69 27.5 34C27.5 31.0825 27.5 26.3125 27.5 23.5863C27.5 22.9825 27.0675 22.465 26.4738 22.3562L24.785 22.05ZM21.3663 21.4275L16.6975 20.5788C15.575 20.375 14.425 20.375 13.3025 20.5788L8.63375 21.4275L7.63625 22.9238L8.13 24.3213L10.5 25.3537C10.8138 25.4912 11.0575 25.7512 11.175 26.0737C11.2925 26.3962 11.2712 26.7525 11.1175 27.0588L10.1625 28.9688L13.6525 35.25H16.3475L19.8375 28.9688L18.8825 27.0588C18.7288 26.7525 18.7075 26.3962 18.825 26.0737C18.9425 25.7512 19.1862 25.4912 19.5 25.3537L21.87 24.3213L22.3638 22.9238L21.3663 21.4275ZM5.215 22.05L3.52625 22.3562C2.9325 22.465 2.5 22.9825 2.5 23.5863V34C2.5 34.69 3.06 35.25 3.75 35.25H10.7925L7.6575 29.6075C7.4575 29.2462 7.4475 28.81 7.6325 28.4412L8.2925 27.12L6.6325 26.3963C6.315 26.2575 6.06875 25.9925 5.95375 25.6662L5.07125 23.1662C4.94 22.795 4.99125 22.3838 5.21 22.0563L5.215 22.05ZM23.75 29V31.5C23.75 32.19 24.31 32.75 25 32.75C25.69 32.75 26.25 32.19 26.25 31.5V29C26.25 28.31 25.69 27.75 25 27.75C24.31 27.75 23.75 28.31 23.75 29ZM15 0.25C10.5163 0.25 6.875 3.89125 6.875 8.375C6.875 12.8587 10.5163 16.5 15 16.5C19.4837 16.5 23.125 12.8587 23.125 8.375C23.125 3.89125 19.4837 0.25 15 0.25ZM15 2.75C18.105 2.75 20.625 5.27 20.625 8.375C20.625 11.48 18.105 14 15 14C11.895 14 9.375 11.48 9.375 8.375C9.375 5.27 11.895 2.75 15 2.75Z"
        fill="white"
      />
    </svg>
  );
};

const reportsSIcon = (props) => {
  return (
    <div style={{ width: width }}>
      <svg
        width="20"
        height="26"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.57143 10.7143C7.36607 10.7143 6.42857 9.77679 6.42857 8.57143C6.42857 7.43304 7.36607 6.42857 8.57143 6.42857C9.70982 6.42857 10.7143 7.43304 10.7143 8.57143C10.7143 9.77679 9.70982 10.7143 8.57143 10.7143ZM13.3929 8.57143C13.3929 7.70089 14.0625 6.96429 15 6.96429H21.4286C22.2991 6.96429 23.0357 7.70089 23.0357 8.57143C23.0357 9.50893 22.2991 10.1786 21.4286 10.1786H15C14.0625 10.1786 13.3929 9.50893 13.3929 8.57143ZM13.3929 15C13.3929 14.1295 14.0625 13.3929 15 13.3929H21.4286C22.2991 13.3929 23.0357 14.1295 23.0357 15C23.0357 15.9375 22.2991 16.6071 21.4286 16.6071H15C14.0625 16.6071 13.3929 15.9375 13.3929 15ZM13.3929 21.4286C13.3929 20.558 14.0625 19.8214 15 19.8214H21.4286C22.2991 19.8214 23.0357 20.558 23.0357 21.4286C23.0357 22.3661 22.2991 23.0357 21.4286 23.0357H15C14.0625 23.0357 13.3929 22.3661 13.3929 21.4286ZM8.57143 12.8571C9.70982 12.8571 10.7143 13.8616 10.7143 15C10.7143 16.2054 9.70982 17.1429 8.57143 17.1429C7.36607 17.1429 6.42857 16.2054 6.42857 15C6.42857 13.8616 7.36607 12.8571 8.57143 12.8571ZM8.57143 23.5714C7.36607 23.5714 6.42857 22.6339 6.42857 21.4286C6.42857 20.2902 7.36607 19.2857 8.57143 19.2857C9.70982 19.2857 10.7143 20.2902 10.7143 21.4286C10.7143 22.6339 9.70982 23.5714 8.57143 23.5714ZM0 4.28571C0 1.94196 1.875 0 4.28571 0H25.7143C28.058 0 30 1.94196 30 4.28571V25.7143C30 28.125 28.058 30 25.7143 30H4.28571C1.875 30 0 28.125 0 25.7143V4.28571ZM3.21429 4.28571V25.7143C3.21429 26.317 3.68304 26.7857 4.28571 26.7857H25.7143C26.25 26.7857 26.7857 26.317 26.7857 25.7143V4.28571C26.7857 3.75 26.25 3.21429 25.7143 3.21429H4.28571C3.68304 3.21429 3.21429 3.75 3.21429 4.28571Z"
          fill={props.color ?? "#303972"}
        />
      </svg>
    </div>
  );
};

function crossIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M18 6L6 18M6 6l12 12"></path>
    </svg>
  );
}


export const Icons = {
  dashboardSIcon,

  customerSIcon,
  accountsSIcon,
  settingsSIcon,
  categoriesSIcon,
  logoutIcon,
  logoIcon,
  totalSalesIcon,
  totalProfitsIcon,
  searchIcon,
  plusIcon,
  imageUplaodIcon,
  eyeIcon,
  clientsDIcon,
  reportsSIcon,
  crossIcon,
  notficationsSIcon
};
